import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type NotificationTemplateFragment = { id: string, name?: string | null, description?: string | null, group?: Types.NotificationGroupTypeEnum | null, actionType: Types.NotificationActionTypeEnum, availableAs: Array<Types.TaskTypeEnum>, defaultReminderType?: Types.ReminderTypeEnum | null, areRemindersGloballyConfigurable?: boolean | null, tasksRequired: { email?: boolean | null, bell?: boolean | null }, reminderConfigurations?: Array<{ reminderType: Types.ReminderTypeEnum, value: number, unit: Types.ReminderConfigurationUnitTypeEnum }> | null };


export type NotificationTemplateFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const NotificationTemplateFragmentDoc = /*#__PURE__*/ gql`
    fragment NotificationTemplate on NotificationTemplate {
  id
  name
  description
  group
  actionType
  tasksRequired {
    email
    bell
  }
  availableAs
  reminderConfigurations {
    reminderType
    value
    unit
  }
  defaultReminderType
  areRemindersGloballyConfigurable
}
    `;